import LoadingAnimation from "components/LoadingAnimation/LoadingAnimation";
import SearchAndCreateBar from "components/SearchAndCreateBar/SearchAndCreateBar";
import { useHttpClient } from 'hooks/http-hook';
import { useAuth } from "providers/AuthProvider";
import { useEffect, useMemo, useState } from "react";
import { resolveFiles } from "utils";
import './Homepage.scss';
import HomeQuickModal from "components/HomeQuickModal/HomeQuickModal";

const Homepage = () => {
	const { token } = useAuth();
	const { sendRequest, isLoading } = useHttpClient();
	const [offCanvasPanelVisible, setOffCanvasPanelVisible] = useState(false);
	const [randomWallpaper, setRandomWallpaper] = useState(null);
	const [wallpaperUrl, setWallpaperUrl] = useState(null);
	const [wallPaperStyles, setWallPaperStyles] = useState(null);
	const [openQuickModal, setOpenQuickModal] = useState(false);

	useEffect(() => {
		const fetchRandomWallpaper = async () => {
      try {
        const response = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/wallpapers/random/1/false`, 'GET', null, {Authorization: `Bearer ${token}`}); // '/false' = sending privateMode false so homepage wallpapers only use public ones 
				const wallpaper = response.wallpapers?.[0] || null;
        setRandomWallpaper(wallpaper);
        if (wallpaper?.file) {
          const resolvedFiles = await resolveFiles([wallpaper.file]);
          setWallpaperUrl(resolvedFiles[0]?.fileUrl || null);
        } else {
          setWallpaperUrl(null);
        }
      } catch (err) {
        console.error('Error fetching random wallpaper:', err);
      }
    };

    fetchRandomWallpaper();
	}, [sendRequest, token]);

	// Toggles the Create Nav (with icons) Panel
	const toggleOffCanvasPanelVisibility= () => {
		setOffCanvasPanelVisible(!offCanvasPanelVisible);
	}

	// TODO: Delete:
	// const wallPaperStyles = useMemo(() => {
	// 	let styles = {};
	// 	if (randomWallpaper?.css) {
	// 		try {
	// 			styles = JSON.parse(randomWallpaper.css);
	// 		} catch (err) {
	// 			console.error("Invalid wallpaper CSS JSON:", err);
	// 		}
	// 	}
	// 	if (wallpaperUrl) styles.backgroundImage = `url(${wallpaperUrl})`;
	// 	return styles;
	// }, [randomWallpaper, wallpaperUrl]);

	useEffect(() => {
		console.log('randomWallpaper', randomWallpaper);
    let css = randomWallpaper?.css || "";

    if (wallpaperUrl) {
      css += `
      .wallpaper {
        background-image: url("${wallpaperUrl}");
      }
    `;
    }

    setWallPaperStyles(css);
  }, [randomWallpaper, wallpaperUrl]);

	if (isLoading) return <LoadingAnimation asOverlay />;

	if (!randomWallpaper) {
    return (
      <div className="homepage">
				<SearchAndCreateBar
					className="search-and-create-bar--black-transparent"
					onUse={toggleOffCanvasPanelVisibility}
				/>
			</div>
    );
  }

	return (
		<>
			<style>{wallPaperStyles}</style>
			<div className="homepage wallpaper">
				<button className="homepage__open-quick-modal-button" onClick={() => setOpenQuickModal(true)}></button>
				<SearchAndCreateBar
					className="search-and-create-bar--black-transparent"
					onUse={toggleOffCanvasPanelVisibility}
				/>
				<HomeQuickModal open={openQuickModal} onClose={() => setOpenQuickModal(false)} />
			</div>
		</>
	);
};

export default Homepage;